import Seo from "../components/Seo";
import { BookHeart } from "lucide-react";
import DonationForm from "../components/DonationForm";

export default function Dona() {
  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-10" data-testid="dona-page">
      <Seo title="Dona i tuoi libri usati | Libri in Circolo" description="Dona i libri che non leggi più alla biblioteca di scambiamocelo.it: verranno rimessi in circolo gratuitamente tra i cittadini della tua zona." path="/dona" />
      <div className="text-center mb-8">
        <div className="w-14 h-14 rounded-2xl bg-secondary/15 text-secondary flex items-center justify-center mx-auto mb-4"><BookHeart className="w-7 h-7" /></div>
        <h1 className="text-3xl sm:text-4xl font-serif font-bold tracking-tight">Dona i tuoi libri alla biblioteca</h1>
        <p className="text-muted-foreground mt-3 max-w-xl mx-auto">
          Hai libri che non leggi più e vuoi che continuino a vivere? Donali alla biblioteca di scambiamoceli.it: entreranno in circolo e raggiungeranno nuovi lettori della zona. Compila il modulo: il bibliotecario ti contatterà per organizzare la consegna.
        </p>
      </div>
      <DonationForm />
    </div>
  );
}
